import axios, { type InternalAxiosRequestConfig } from 'axios';
import store from '@/store';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = store.getters['token'];
  if (!config.headers) config.headers = {} as typeof config.headers;
  config.headers['Accept-Language'] = 'pl';

  if (token) {
    config.headers['key'] = token;
  } else {
    delete config.headers['key'];
  }

  return config;
});

//handle api errors
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 404) {
      console.log('error'); //to do toast
    }
    return Promise.reject(error);
  }
);

export default instance;
